// extracted by mini-css-extract-plugin
module.exports = {"jobCard-viewedBadge":"jobCard-viewedBadge","jobCard-viewedBadge__text":"jobCard-viewedBadge__text"};